import { render, staticRenderFns } from "./modal2.vue?vue&type=template&id=c0bca57e&scoped=true&"
import script from "./modal2.vue?vue&type=script&lang=js&"
export * from "./modal2.vue?vue&type=script&lang=js&"
import style0 from "./modal2.vue?vue&type=style&index=0&id=c0bca57e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0bca57e",
  null
  
)

export default component.exports